module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ShowMore",
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v("\n  " + _vm._s(_vm.str) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdd26168"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShowMore/ShowMore.vue
// module id = 918
// module chunks = 2